export const getEnv = (envName: Env) => {
    if (typeof window !== 'undefined') {
        return window?.[envName]
    }

    return ''
}

export enum Env {
    GATSBY_NLM_URL = 'GATSBY_NLM_URL',
    GATSBY_REST_API_URL = 'GATSBY_REST_API_URL',
    GATSBY_GRAPHQL_API_URL = 'GATSBY_GRAPHQL_API_URL',
}
